<template>
  <v-card :class="[$root.isRTL ? 'fullContentRTL' : 'fullContent']">
    <v-toolbar dark color="primary" class="fullToolbar">
      <v-toolbar-title class="white--text" style="font-size: 30px; text-align: right;">
        <i class="material-icons icon">group</i>
        משתמשים
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field dark prepend-icon="search" single-line style="padding-top: 20px;" v-model="txtSearch"></v-text-field>
    </v-toolbar>
    <div style="width: 100%;">
      <div style="text-align: right;">
        <v-icon @click="addNew" class="btnAdd" v-tooltip:left="{ html: 'הוסף חדש' }">add</v-icon>
        <input type="checkbox" v-model="isActiveUsers" class="w3-check"> הצג פעיל בלבד
      </div>
      <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
        <tr class="trPrint trHeader">
          <th class="tdData sp">שם מלא</th>
          <th class="tdData">שם משתמש</th>
          <th class="tdData">תעודת זהות</th>
          <!--<th class="tdData">סוג משתמש</th>-->
          <th class="tdData">פעיל</th>
          <th class="tdData">מאושר</th>
          <th class="tdCtrl" style="width: 160px!important;"></th>
        </tr>
      </table>
      <div class="scrollContent" v-if="hasData">
        <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
          <tr v-for="row in filteredRows">
            <td class="tdData sp">{{row.FullName}}</td>
            <td class="tdData tdTxt">{{row.Username}}</td>
            <td class="tdData tdTxt">{{row.Identity}}</td>
            <!--<td class="tdData tdTxt">{{row.Type}}</td>-->
            <td class="tdData">
              <v-icon v-if="row.Active" class="green--text">done</v-icon>
              <v-icon v-else class="red--text">block</v-icon>
            </td>
            <td class="tdData">
              <v-icon v-if="row.Approved" class="green--text">done</v-icon>
              <v-icon v-else class="red--text">block</v-icon>
            </td>
            <td class="tdCtrl tdTxt" style="width: 160px!important;">
              <v-icon @click="edit(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
              <v-icon @click="confirm(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
            </td>
          </tr>
        </table>
      </div>
      <div fluid v-else>
        <h3 style="padding-top: 40px;">אין נתונים</h3>
      </div>
      <PopupUser></PopupUser>
    </div>
  </v-card>
</template>

<script>
  import jsonp from 'jsonp';
  import axios from 'axios';

  import { db } from '../firebase';
  var usersRef = db.ref('Users');
  import PopupUser from '../components/PopupUser';

  export default {
    name: 'Users',
    components: { PopupUser },
    data() {
      return {
        txtSearch: '',
        users: [],
        isActiveUsers: false,
        popup: {
          isVisible: false,
          title: '',
          question: '',
          caller: '',
          isConfirmed: false,
          data: { '.key': '', FullName: '', Username: '', Identity: '', Type: '', Password: '', Active: false, Approved: false },
        }
      }
    },
    firebase: function () {
      var vm = this;
      return {
        users: usersRef.orderByChild("Type").equalTo("מנהל מערכת"),
      }
    },
    created() {
      this.$Log("Vue [Users] is created ...");
    },
    ready() {
      this.$Log("Vue [Users] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Users] is mounted ...");
    },
    updated() {
      this.$Log("Vue [Users] is updated ...");
    },
    computed: {
      hasData() {
        return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
      },
      filteredRows() {
        var vm = this;
        if (vm.txtSearch.length > 0) {
          var result = [];
          try {
            result = vm.users.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                  if (vm.isActiveUsers) {
                    if (row.Active) {
                      return row;
                    }
                  }
                  else {
                    return row;
                  }
                }
              })
            });
          }
          catch (e) {
          }
        }
        else {
          if (vm.isActiveUsers) {
            result = vm.users.filter(function (row) {
              if (row.Active) {
                return row;
              }
            });
          }
          else {
            result = vm.users;
          }
        }

        return result;
      }
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'RemoveUser') {
          this.remove();
        }
      }
    },
    methods: {
      currency(N) {
        N = parseFloat(N);
        if (!isNaN(N))
          N = N.toFixed(2);
        else
          N = '0.00';
        return N + " ₪";
      },
      addNew() {
        this.popup = {
          isVisible: true,
          isEdit: false,
          title: 'משתמש חדש',
          data: { '.key': '', FullName: '', Username: '', Identity: '', Type: 'מנהל מערכת', Password: '', Active: false, Approved: false }
        };
      },
      edit(row) {
        this.popup = {
          isVisible: true,
          isEdit: true,
          title: 'עריכת משתמש',
          data: {
            '.key': row['.key'],
            FullName: row.FullName,
            Username: row.Username,
            Identity: row.Identity,
            Type: row.Type,
            Password: row.Password,
            Active: row.Active,
            Approved: row.Approved
          }
        };
      },
      confirm(row) {
        this.popup.data = row;
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
          caller: 'RemoveUser',
          isConfirmed: false
        }
      },
      remove() {
        usersRef.child(this.popup.data['.key']).remove();
      },
      insert() {
        var item = {
          FullName: this.popup.data.FullName,
          Username: this.popup.data.Username,
          Identity: this.popup.data.Identity,
          Type: this.popup.data.Type,
          Password: this.popup.data.Password,
          Active: this.popup.data.Active,
          Approved: this.popup.data.Approved
        };

        usersRef.push(item);

        var createUserUrl = "https://us-central1-getnet-c2357.cloudfunctions.net/CreateUser";
        createUserUrl = createUserUrl + "?" + "userData=" + JSON.stringify(item);

        jsonp(createUserUrl, {}, function (error, data) {
          console.log("user ERROR >> " + error);
          console.log("user DATA >> " + data);
          console.log("user ERROR >> " + JSON.stringify(error));
          console.log("user DATA >> " + JSON.stringify(data));
        }); 

        //var request = {
        //  url: 'https://us-central1-getnet-c2357.cloudfunctions.net/CreateUser',
        //  method: 'post',
        //  responseType: 'json',
        //  data: item
        //};

        //axios(request).then(function (response) {
        //  if (response.data.code == 0) {
        //    console.log("success user >> " + response.data);
        //  }
        //  else {
        //    console.log("error user >> " + response.data.messages);
        //  }
        //}).catch(function (error) {
        //  console.log("error user (catch) >> " + error);
        //});
      },
      update() {
        var item = {
          FullName: this.popup.data.FullName,
          Username: this.popup.data.Username,
          Identity: this.popup.data.Identity,
          Type: this.popup.data.Type,
          Password: this.popup.data.Password,
          Active: this.popup.data.Active,
          Approved: this.popup.data.Approved
        };
        usersRef.child(this.popup.data['.key']).set(item);
      }
    }
  }

</script>
<style scoped>
  .RTL {
    text-align: right;
  }

    .RTL > tr > td {
      text-align: right;
    }

  .iconArrow2RTL {
    left: -220px;
  }

  .toolbar__title i {
    color: #fff;
    font-size: 30px;
  }

  .toolbar .toolbar__content {
    width: 100% !important;
  }


  .lblTop {
    color: #888;
    font-size: 11px;
    display: block;
    text-align: left;
  }

  .lblTopRTL {
    color: #888;
    font-size: 11px;
    display: block;
    text-align: right;
  }

  .smallRemove {
    float: right;
    padding-left: 10px;
    padding-top: 5px;
    cursor: pointer;
  }

  .btnSend {
    height: 35px;
  }

  .tabs__items {
  }

  .tabs__item {
    text-transform: none !important;
    background-color: #f2f2f2;
    color: #02589B !important;
    border-bottom: 2px solid #02589B;
    padding: 0px 10px !important;
  }

  .divOr {
    color: #02589B;
    text-align: center;
    width: 100%;
  }

  .noData {
    padding: 30px;
    width: 100%;
    text-align: center !important;
    font-size: 20px;
    color: #ccc;
  }

  .cardBlue {
    margin: 0px;
    width: 100% !important;
    height: 100% !important;
    overflow: hidden;
  }

  .blueTitle {
    width: 96%;
    text-align: left;
  }

  .blueTitleRTL {
    width: 96%;
    text-align: right;
  }

  .blueLink {
    text-align: right;
    font-size: 25px;
    font-weight: lighter;
    color: #fff !important;
    cursor: pointer;
  }

  .lblCommunity {
    font-size: 14px;
    width: 100%;
    text-align: left;
    display: block;
  }

  .lblCommunityRTL {
    font-size: 14px;
    width: 100%;
    text-align: right;
    display: block;
  }

  .imgUser {
    width: 50px;
    height: 50px;
    border-radius: 50px;
  }

  .cardBlue .card__title {
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0px;
    background-color: rgb(1, 87, 155);
    height: 40px !important;
    font-size: 13px;
    color: #fff;
  }

  .dialog > .card .card__title {
    padding: 10px;
  }

  .tblUsers {
    width: 100%;
    border-spacing: 0px;
    border-collapse: collapse;
  }

  table.tblUsers > thead > tr {
    border-bottom: 2px solid #ccc;
  }

    table.tblUsers > thead > tr > td {
      color: #02589B;
      font-weight: bold;
      border-bottom: 2px solid #ccc;
      text-align: left;
      padding-bottom: 10px;
    }

  table.tblUsers > tbody > tr > td {
    text-align: left;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 2px solid #ccc;
  }

  .avatar {
    text-align: center;
    width: 70px;
  }

  .edit {
    width: 30px;
  }

    .edit > i {
      color: #02589B !important;
      cursor: pointer;
      font-size: 30px;
    }

  .overlay--active {
    z-index: 19000 !important;
  }

  .dialog__content {
    z-index: 20000 !important;
  }

  .input-group__input {
    border: none !important;
  }

  .divTabs {
    width: auto;
    border-bottom: 2px solid #01579B;
    margin: 5px 20px 10px 20px;
  }

  .divTabContent {
    height: 400px;
  }

  .tabTitle {
    color: #999;
    line-height: 40px;
    display: block;
    cursor: pointer;
  }

    .tabTitle:hover {
      color: #02589B;
    }

  .arrow {
    position: relative;
    color: #02589B;
  }

    .arrow:after {
      border: solid transparent;
      content: " ";
      display: block;
      height: 0;
      position: absolute;
      pointer-events: none;
      width: 0;
      top: 100%;
      border-color: rgba(255, 255, 255, 0);
      border-top-color: #02589B;
      left: 50%;
      margin-left: -10px;
      border-width: 10px;
    }

  .divLogo {
    color: #c9c9c9;
    background-color: #e4e4e4;
    width: 60px;
    height: 60px;
    border-radius: 100%;
    line-height: 60px;
    font-size: 20px;
  }

  .iconArrow2 {
    opacity: 1;
    position: relative;
    top: -30px;
    left: 210px;
    color: #999999;
    font-size: 20px;
  }

  .chk {
    padding-top: 5px;
  }

  .chkRTL {
    padding-top: 10px;
    margin-top: 7px;
    margin-left: 5px;
  }

  .chkSpan {
    color: #999999;
    padding-left: 10px;
    font-size: 13px;
  }

  .chkSpanRTL {
    text-align: right;
  }

  .sideLeft {
    float: left;
    padding-left: 10px;
    padding-top: 15px;
    font-weight: normal;
    padding: 15px;
  }

    .sideLeft > i {
      font-size: 20px;
      padding-bottom: 5px;
    }

    .sideLeft > span {
      padding-top: 15px;
      margin-top: 15px;
    }

  .sideRight {
    float: right;
    padding-top: 15px;
    font-weight: normal;
    padding: 15px;
  }

    .sideRight > i {
      font-size: 20px;
      font-weight: bold;
      padding-bottom: 4px;
    }

    .sideRight > span {
    }
</style>



// WEBPACK FOOTER //
// Users.vue?e4cf4170